var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_vm._v("Angebote werden gesucht, bitte warten.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }